import React from 'react';
import { Link } from 'react-router-dom';

import MenuItem from './MenuItem';
import { logo } from '../../components/Images';

export default function Sidebar() {
    return (
        <div className='w-64 hidden lg:flex'>
            <div className='fixed w-64 h-full bg-secondary z-10 overflow-y-auto overflow-x-hidden'>
                <Link to='/' className='flex p-6 pl-10 sticky top-0 z-[10] bg-secondary'>
                    <img src={logo} alt={'alt'} className='h-14 w-32 object-contain' />
                </Link>
                <MenuItem type={'desktop'} />
            </div>
        </div>
    )
}